import { Component, inject } from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { IonSpinner } from '@ionic/angular/standalone';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.css'],
  imports: [IonSpinner],
})
export class LoadingSpinnerComponent {
  themeService = inject(ThemeService);
}
